/**
 * Google Maps configuration.
 *
 * The API key is hardcoded here rather than a NEXT_PUBLIC_* env var for the
 * same reason as the PostHog token and Meta Pixel ID: a missing build-time
 * env var silently breaks client integrations on deploy. A Maps key is
 * meant to live in client-side code anyway.
 *
 * IMPORTANT — two things must be set on this key in the Google Cloud
 * console (Credentials → this key) or the map breaks or gets abused:
 *   1. Application restriction → HTTP referrers → areaadvertising.com/*,
 *      www.areaadvertising.com/*, dev.areaadvertising.com/* (and any other
 *      domain that should show the map). Without this, the key can be
 *      lifted from page source and used elsewhere on your bill.
 *   2. API restriction → enable the "Maps Embed API". The key was created
 *      for Locator Plus (Maps JavaScript API); the Embed API is separate.
 */
export const GOOGLE_MAPS_API_KEY = "AIzaSyAg1f668S07l6K6MVpV0BX0b8S18YDIkRU";

/** Google Place ID for the Ashland, KY shop (824 Winchester Avenue). */
export const MAPS_PLACE_ID = "ChIJx2KYeCB0RogRCv01Wgr7h9k";
